export enum Tabs {
  ContentSearch,
  Embargoed,
  PublishHistory,
  Settings
}
